export const isNoteEmpty = (note: {
  title?: string | null | undefined;
  body?: string | null | undefined;
}) => {
  return note.title === '' && note.body === '';
};

export * from './noteColors';
